import { AsyncAction } from '../../base-classes/asyncAction';
import { WeatherCamProvider } from '../providers/weatherCamProvider';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_WEATHER_CAMS = new AsyncAction('GET_WEATHER_CAMS');
export const GET_WEATHER_CAM_DETAIL = new AsyncAction('GET_WEATHER_CAM_DETAIL');
export const GET_WEATHER_CAMS_WITH_GEOJSON = new AsyncAction('GET_WEATHER_CAMS_WITH_GEOJSON');

export function getWeatherCams(...params) {
    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        radius: undefined,
        noOfStations: undefined,
        includeImages: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        options: undefined,
        logger: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined
    };

    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_WEATHER_CAMS.base,
        payload: getWeatherCamsAction(paramsObject)
    };
}

async function getWeatherCamsAction({ latitude, longitude, radius, noOfStations, includeImages, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh }) {
    const op = new WeatherCamProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getWeatherCams(latitude, longitude, radius, noOfStations, includeImages, stdParameters, verbose, refresh);
    return results;
}

export function getWeatherCamDetail(cameraId, includeTimelapse, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    return {
        type: GET_WEATHER_CAM_DETAIL.base,
        payload: getWeatherCamDetailAction(cameraId, includeTimelapse, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh)
    };
}

async function getWeatherCamDetailAction(cameraId, includeTimelapse, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    const op = new WeatherCamProvider(baseUrl, authId, secret, options, logger);
    const results = await op.getWeatherCamDetail(cameraId, includeTimelapse, stdParameters, verbose, refresh);
    return results;
}

export function getWeatherCamsWithGeoJson(latitude, longitude, radius, noOfStations, includeImages, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh) {
    return {
        type: GET_WEATHER_CAMS_WITH_GEOJSON.base,
        payload: getWeatherCamsAction({ latitude, longitude, radius, noOfStations, includeImages, baseUrl, authId, secret, options, logger, stdParameters, verbose, refresh })
    };
}
